// extracted by mini-css-extract-plugin
export default {"root":"OptedOut_root__HM6Nt","fullName":"OptedOut_fullName__1rNqZ","organization":"OptedOut_organization__SZOl0","fullWidth":"OptedOut_fullWidth__6qCYt"};